/**
 * Check if a PDF file is password-protected by attempting to parse its structure
 * 
 * @param {File|Blob} file - The PDF file to check
 * @returns {Promise<boolean>} - Returns true if password-protected, false otherwise
 */
export const checkPasswordProtectedPdf = async (file) => {
  try {
    // Read the file as ArrayBuffer
    const arrayBuffer = await file.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);
    
    // Convert bytes to string for pattern matching
    const text = new TextDecoder('latin1').decode(bytes);
    
    // Check for encryption dictionary markers in PDF structure
    // Password-protected PDFs contain /Encrypt dictionary
    const hasEncryptDict = text.includes('/Encrypt');
    
    // Check for standard security handler
    const hasStandardSecurity = text.includes('/Standard');
    
    // Check for user/owner password markers
    const hasPasswordMarkers = text.includes('/U') && text.includes('/O');
    
    // If all encryption indicators are present, PDF is likely password-protected
    if (hasEncryptDict && (hasStandardSecurity || hasPasswordMarkers)) {
      return true;
    }
    
    return false;
  } catch (error) {
    // If there's an error reading the file, return false and let normal error handling take over
    return false;
  }
};

